import React, { useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

export function AccordionSection({ id, collapseId, headerId, number, title, isComplete, startOpen, children }) {
  const [isOpen, setIsOpen] = useState(!!(startOpen && !isComplete));

  return (
    <div className="accordion-item" id={id}>
      <h2 className="accordion-header" id={headerId}>
        <button
          className={`accordion-button ${isOpen ? "" : "collapsed"}`}
          type="button"
          onClick={() => setIsOpen((o) => !o)}
          aria-expanded={isOpen}
          aria-controls={collapseId}
        >
          {number}. {title} {isComplete ? " - Complete " : ""}
          {isComplete ? <FontAwesomeIcon icon={faCircleCheck} className="fa ms-2 me-2" /> : ""}
        </button>
      </h2>
      <div
        id={collapseId}
        className={`accordion-animate ${isOpen ? "open" : ""}`}
        aria-labelledby={headerId}
      >
        <div>
          <div className="accordion-body">{children}</div>
        </div>
      </div>
    </div>
  );
}

AccordionSection.propTypes = {
  id: PropTypes.string.isRequired,
  collapseId: PropTypes.string.isRequired,
  headerId: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  isComplete: PropTypes.bool,
  startOpen: PropTypes.bool,
  children: PropTypes.node,
};
